export default {"src":"/_next/static/media/brands.f18bb814.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};